var configPromise = require('../config').configPromise;
var Api = require('./api');


var MiscueSessionApi = {

  getRecentMiscueSessions(pageObject, learnerId){
    learnerId = learnerId || "";
    return configPromise.then(function (config) {
      return Api.get(config.apiPath('/api/miscueSessions/recent/{0}', [learnerId]), pageObject)
    });
  },

  /*api/miscueSessions/{id}*/
  getMiscueSessionDetails(sessionId){
    return configPromise.then(function (config) {
      return Api.get(config.apiPath('/api/miscueSessions/{0}', [sessionId]));
    });
  },

  deleteMiscueSession(idsList) {
    return configPromise.then(function (config) {
      return Api.delete(config.apiPath('/api/miscueSessions'), {idsList})
    });
  },

  getMiscueTypes(){
    return configPromise.then(function (config) {
      return Api.get(config.apiPath('/api/miscueSessions/dict/miscueTypes'));
    });
  },

  getMiscueYearGroups(){
    return configPromise.then(function (config) {
      return Api.get(config.apiPath('/api/miscueSessions/dict/yearGroups'));
    });
  },

  getMiscueBookBands(){
    return configPromise.then(function (config) {
      return Api.get(config.apiPath('/api/miscueSessions/dict/bookBands'));
    });
  },

  saveMiscueSessionNote(sessionId, noteText){
    return configPromise.then(function (config) {
      return Api.patch(config.apiPath('/api/miscueSessions/{0}/notes', [sessionId]), noteText);
    });
  },

  saveMiscueItem(miscueItemId, miscueItemText){
    return configPromise.then(function (config) {
      return Api.patch(config.apiPath('/api/miscueSessions/miscue/{0}', [miscueItemId]), miscueItemText);
    });
  },

  deleteMiscueItem(miscueItemId){
    return configPromise.then(function (config) {
      return Api.delete(config.apiPath('/api/miscueSessions/miscue/{0}', [miscueItemId]));
    });
  }

};

module.exports = MiscueSessionApi;
